import { LocationsService } from '@api/v3';
import { callService } from '@api/remote-call';

const runLocationsOnClientOrServer = (
  resource: 'listCountries' | 'listCountriesWithCode'
) => {
  if (typeof window === 'undefined') return LocationsService[resource]();
  else
    return callService({
      service: 'LocationsService',
      method: resource,
      version: 'v3',
    });
};

const fetchCountries = async () => {
  const [countries, countriesWithCode] = await Promise.all([
    runLocationsOnClientOrServer('listCountries'),
    runLocationsOnClientOrServer('listCountriesWithCode'),
  ]);
  const CountryNameCodeMap = countriesWithCode.reduce((acc, c) => {
    acc[c.name as string] = c.code as string;
    return acc;
  }, {} as { [name: string]: string });
  return countries.map((c) => ({
    ...c,
    cCode: CountryNameCodeMap[c.name as string],
    id: +(c.code ?? 0),
  }));
};

export default fetchCountries;
